module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/wheel-icon-0a3cc92b5a363d9c000054a4d133c42a.png";